// extracted by mini-css-extract-plugin
export default {"search_bar":"SearchBar_search_bar__DBB32","search_container":"SearchBar_search_container__6ivQB","icon_container":"SearchBar_icon_container__L7SRn"};